let forms = {
   voucher_code: {
      icon: 'fa fa-university',
      title: 'Search Account',
      subtitle: 'Provide Account Details',
      forms: [
         { type: "text", form_type: "text", class: "col-12", validation: "required|min:6|max:6", model: "pass_code", label: '<i class="fa fa-lock"></i> Code', sub_label: 'The code sent to you via SMS and E-Mail.'},
         { type: 'button', btnClass: 'btn-primary btn-long', class: 'col-12', model: 'validate_code', label: 'Validate Code'}
      ]
   },
}

export default {
   forms: utils.generateAllFormData(forms),
}